// Checklist - PAVADINIMAS (puslapis)

page.checklist.BuyingCultures = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first(); // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.culture-content').length > 0){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: BUYING CULTURES detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.

        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);

        /* page.control.particles.speedTo(0.1, 1000);
        page.control.particles.fadeTo(0.2, 1500);
        page.control.particles.scrolling(true); */

        page.main.fr.cultureLinks.init();
        page.main.fr.infoPopup.init();
        page.main.fr.initSelect();
        page.main.fr.tooltipster.init();

        let hash = window.location.hash;


        if(hash){
            $('html, body').animate({
                scrollTop: $(hash.replace('%C5%B3', 'ų')).offset().top - 50
            }, 800);
        }

        $('.js-dropdown').change(function(){

            console.log('js-dropdown change');
            let $this = $(this);

            $('.culture-content-txt').hide();
            if($this.find(":selected").hasClass('empty')){

               let id =  $('[value="'+$this.val()+'"]').next().val();
               $('.requirements-extra').slideUp();
                setTimeout(function () {
                    $('.js-dropdown').val(id).select2({
                        language: "lt",
                        minimumResultsForSearch: Infinity,
                        templateResult: formatItem
                    }).trigger('change');


                    function formatItem(state) {

                        if (state.id == 'undefined') {
                            return;
                        }

                        if (!state.id) {


                            return state.text;
                        }
                        var $state = $(
                            '<span class="' + state.element.className + '">' + state.text + '</span>'
                        );
                        return $state;
                    }

                    $(id).show();
                }) // setTimeout fixed error msg

            }else{
                $($this.val()).show()
            }
        });

        $('.requirements-toggle').click(function(e){
            e.preventDefault();

            let $target = $(this).next();
            if($target.hasClass('requirements-extra')){
                $target.slideToggle();
            }
        });

        page.main.fr.altMenu.alt();
        page.main.v.marketSticky.play(0);
        this.resize();
    },
    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį

    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        //page.control.bg.fadeColor(0,600);
        page.main.fr.cultureLinks.destroy();
        page.main.fr.infoPopup.destroy();
        page.main.fr.tooltipster.destroy();
        $('.requirements-toggle').off();
    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)

    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}